import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationStateService } from '@core/service/application-state.service';
import { API_URL } from '@core/constants';
import { IUrgentNotification } from '@core/model';

@Injectable({
  providedIn: 'root',
})
export class UrgentNotificationService {
  constructor(
    public http: HttpClient,
    private applicationStateService: ApplicationStateService,
    @Inject(API_URL) private apiUrl: string
  ) {}

  getUrgentNotifications(
    authorizationByProductId: string,
    productLineId: string
  ): Observable<IUrgentNotification[]> {
    return this.http.get<IUrgentNotification[]>(
      `${this.apiUrl}/api/tenants/${this.applicationStateService.tenantId}/authorizations/${authorizationByProductId}/productLine/${productLineId}/UrgentNotifications`
    );
  }

  getUrgentNotificationById(
    authorizationByProductId: string,
    productLineId: string,
    urgentNotificationId: string
  ): Observable<IUrgentNotification> {
    return this.http.get<IUrgentNotification>(
      `${this.apiUrl}/api/tenants/${this.applicationStateService.tenantId}/authorizations/${authorizationByProductId}/productLine/${productLineId}/UrgentNotifications/${urgentNotificationId}`
    );
  }

  createUrgentNotification(
    authorizationByProductId: string,
    productLineId: string,
    payload: IUrgentNotification
  ): Observable<IUrgentNotification> {
    return this.http.post<IUrgentNotification>(
      `${this.apiUrl}/api/tenants/${this.applicationStateService.tenantId}/authorizations/${authorizationByProductId}/productLine/${productLineId}/UrgentNotifications`,
      payload
    );
  }

  updateUrgentNotification(
    authorizationByProductId: string,
    productLineId: string,
    payload: IUrgentNotification
  ): Observable<IUrgentNotification> {
    return this.http.put<IUrgentNotification>(
      `${this.apiUrl}/api/tenants/${this.applicationStateService.tenantId}/authorizations/${authorizationByProductId}/productLine/${productLineId}/UrgentNotifications`,
      payload
    );
  }
}
